import { render, staticRenderFns } from "./CvPreviewNavSp.vue?vue&type=template&id=60d5955d&scoped=true&"
import script from "./CvPreviewNavSp.vue?vue&type=script&lang=ts&"
export * from "./CvPreviewNavSp.vue?vue&type=script&lang=ts&"
import style0 from "./CvPreviewNavSp.vue?vue&type=style&index=0&id=60d5955d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60d5955d",
  null
  
)

export default component.exports